import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=b65b857c&scoped=true&"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js&"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=b65b857c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65b857c",
  null
  
)

/* custom blocks */
import block0 from "./CopyrightFooter.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b65b857c')) {
      api.createRecord('b65b857c', component.options)
    } else {
      api.reload('b65b857c', component.options)
    }
    module.hot.accept("./CopyrightFooter.vue?vue&type=template&id=b65b857c&scoped=true&", function () {
      api.rerender('b65b857c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CopyrightFooter.vue"
export default component.exports